import { useEffect, useState } from "react";
import { post } from "../networking/RequestService";

const useGetEtiketListByProfileId = (profileId) => {
    const [etiketList, setEtiketList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchEtiketList = async () => {
        if (!profileId) return;

        setLoading(true);
        setError(null);
        try {
            const res = await post({
                fn: "getEtiketListByProfileId",
                profileId,
            });

            setEtiketList(res.data.etikets || []);
        } catch (err) {
            setError(err);
            setEtiketList([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchEtiketList();
    }, [profileId]);

    return { etiketList, loading, error, refetch: fetchEtiketList };
};

export default useGetEtiketListByProfileId;
